import { Button, type ButtonProps } from '@mui/material'

interface BtnProps extends ButtonProps {
  component?: any
  text?: string
  to?: string
}

const Btn: React.FC<BtnProps> = ({ component, to, text, color, variant, startIcon, onClick, disabled, sx }) => {
  return (
    <Button
      component={component}
      to={to}
      color={color}
      variant={variant}
      startIcon={startIcon}
      onClick={onClick}
      disabled={disabled}
      style={{ boxShadow: 'none' }}
      sx={sx}
      aria-disabled={disabled}
    >
        {text}
    </Button>
  )
}

export default Btn
